import { render, staticRenderFns } from "./myWellbeingDiary.vue?vue&type=template&id=64fad1da&"
import script from "./myWellbeingDiary.vue?vue&type=script&lang=js&"
export * from "./myWellbeingDiary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports